import { Avatar } from '@backstage/core-components';
import { Box } from '@material-ui/core';
import { Link } from '@backstage/core-components';

interface CardTitleProps {
  title: string;
  picture: string;
  link: string;
}

function CardTitle({ title, picture, link }: CardTitleProps) {
  return (
    <Box display="flex" alignItems="center">
      <Avatar displayName={title} picture={picture} />
      <Box ml={1}>
        <Link to={link}>{title}</Link>
      </Box>
    </Box>
  );
}

export { CardTitle };
